import { Condition } from "./medication-condition-pairs";
import { SurveyTag } from "./survey-tags";

export interface MedicalInfoTab {
  id: string;
  label: string;
  route: string;
  surveyTag: SurveyTag;
}

export const DEFAULT_MEDICAL_INFO_TABS: MedicalInfoTab[] = [
  {
    id: "diagnosis",
    label: "Diagnosis",
    route: "diagnosis",
    surveyTag: SurveyTag.DIAGNOSIS,
  },
  {
    id: "medication-history",
    label: "Medication History",
    route: "medication-history",
    surveyTag: SurveyTag.MEDICATION_HISTORY,
  },
];

export const CONDITION_MEDICAL_INFO_TABS: Partial<
  Record<Condition, MedicalInfoTab[]>
> = {
  [Condition.HYPOPHOSPHATASIA]: [
    {
      id: "laboratory-results",
      label: "Laboratory Results",
      route: "laboratory-results",
      surveyTag: SurveyTag.LABORATORY_RESULTS,
    },
    {
      id: "genetic-testing",
      label: "Genetic Testing",
      route: "genetic-testing",
      surveyTag: SurveyTag.GENETIC_TESTING,
    },
    {
      id: "disease-onset-diagnosis-timeline",
      label: "Disease Onset & Diagnosis Timeline",
      route: "disease-onset-diagnosis-timeline",
      surveyTag: SurveyTag.DISEASE_ONSET_DIAGNOSIS_TIMELINE,
    },
    {
      id: "skeletal-manifestations",
      label: "Skeletal Manifestations",
      route: "skeletal-manifestations",
      surveyTag: SurveyTag.SKELETAL_MANIFESTATIONS,
    },
    {
      id: "non-skeletal-systemic-manifestations",
      label: "Non-Skeletal Systemic Manifestations",
      route: "non-skeletal-systemic-manifestations",
      surveyTag: SurveyTag.NON_SKELETAL_SYSTEMIC_MANIFESTATIONS,
    },
    {
      id: "disease-progression",
      label: "Disease Progression",
      route: "disease-progression",
      surveyTag: SurveyTag.DISEASE_PROGRESSION,
    },
  ],
};

export function getMedicalInfoTabsForCondition(
  condition: string | null | undefined,
): MedicalInfoTab[] {
  if (!condition) {
    return DEFAULT_MEDICAL_INFO_TABS;
  }

  const conditionTabs = CONDITION_MEDICAL_INFO_TABS[condition as Condition];
  return conditionTabs ?? DEFAULT_MEDICAL_INFO_TABS;
}

export function getFirstTabRouteForCondition(
  condition: string | null | undefined,
): string {
  const tabs = getMedicalInfoTabsForCondition(condition);
  return tabs[0]?.route ?? "diagnosis";
}
